import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue";
import componentI18n from '@/i18n/componentI18n';
const __default__ = {
    ...componentI18n('components.sidebar.cta_control')
};
import { computed } from 'vue';
import { useStore } from 'vuex';
import { storeToRefs } from 'pinia';
import { event } from 'vue-gtag';
import moment from 'moment';
import BaseCtaSidebarControl from '@/components/sidebar/BaseCtaSidebarControl.vue';
import NonFreeLabel from '@/components/pricing/NonFreeLabel.vue';
import { useRetroStore } from '@/pinia_stores/retro';
import { FEATURE_FLAGS } from '@/constants';
export default /*#__PURE__*/ _defineComponent({
    ...__default__,
    __name: 'CtaSidebarControl',
    emits: ['free-ice-break'],
    setup(__props, { emit }) {
        const isPricingEnabled = FEATURE_FLAGS.PRICING_ENABLED;
        const store = useStore();
        const retroStore = useRetroStore();
        const { currentGroup, currentPoster, expectedPostingTurnDurationInMinutes, hasMotivation, isPreparingIceBreaker, isCurrentUserPosting, isDoneVoting, isDoneWriting, isModerator, isMotivationPending, isOkWithGroups, isOtherUserPosting, isParticipant, isSomeActionLoading, phase, progressModal, startsAt, turnStartedAt, votingMechanic, writingDuration, writingStartedAt, iceBreakerQuestion } = storeToRefs(retroStore);
        const { submitDoneWritingValue, submitDoneVotingValue, submitOkWithGroupsValue } = retroStore;
        const workspace = computed(() => store.getters.workspace);
        const isFreeWorkspace = computed(() => store.getters.isFreeWorkspace);
        const currentPosterFirstName = computed(() => currentPoster.value.name && currentPoster.value.name.split(' ')[0]);
        const iceBreakersRetroStartsAt = computed(() => moment(startsAt.value).format('h:mm A'));
        const shouldButtonBeLoading = computed(() => {
            return isSomeActionLoading.value || progressModal.value;
        });
        const shouldRenderIceBreaker = computed(() => phase.value === 'setup' && !isMotivationPending.value);
        const shouldRenderIceBreakerButton = computed(() => {
            return (!isMotivationPending.value &&
                isModerator.value &&
                !isPreparingIceBreaker.value &&
                iceBreakerQuestion.value === null);
        });
        const shouldRenderDiscussion = computed(() => isParticipant.value && !isModerator.value && phase.value === 'discussion');
        const shouldRenderGroupingWithoutSuggestions = computed(() => {
            return (isParticipant.value && !isModerator.value && phase.value === 'grouping' && isOkWithGroups.value);
        });
        const shouldRenderGroupingWithSuggestions = computed(() => {
            return (isParticipant.value &&
                !isModerator.value &&
                phase.value === 'grouping' &&
                hasMotivation.value &&
                !isOkWithGroups.value);
        });
        const shouldRenderPostingOther = computed(() => {
            return isParticipant.value && phase.value === 'posting' && isOtherUserPosting.value;
        });
        const shouldRenderPostingYou = computed(() => {
            return isParticipant.value && phase.value === 'posting' && isCurrentUserPosting.value;
        });
        const shouldRenderVotingDone = computed(() => {
            return (isParticipant.value && !isModerator.value && phase.value === 'voting' && isDoneVoting.value);
        });
        const shouldRenderVotingNotDone = computed(() => {
            return (isParticipant.value && !isModerator.value && phase.value === 'voting' && !isDoneVoting.value);
        });
        const shouldRenderWritingDone = computed(() => {
            return isParticipant.value && phase.value === 'writing' && isDoneWriting.value;
        });
        const shouldRenderWritingNotDone = computed(() => {
            return isParticipant.value && phase.value === 'writing' && !isDoneWriting.value;
        });
        const canUseIceBreakers = computed(() => !isPricingEnabled || (workspace.value && !isFreeWorkspace.value));
        const votingImage = computed(() => {
            const oneAndTwoImage = require('@/assets/images/sidebarParticipantControl/voting-one-and-two-dude.svg');
            const likeImage = require('@/assets/images/sidebarParticipantControl/voting-like-dude.svg');
            return votingMechanic.value === 'like' ? likeImage : oneAndTwoImage;
        });
        const makeGroupingSuggestions = () => {
            submitOkWithGroupsValue(false);
            event('change_groupings', {
                event_category: 'retro',
                event_label: isModerator.value ? 'moderator' : 'participant'
            });
        };
        const handleBreakTheIce = () => {
            if (canUseIceBreakers.value) {
                isPreparingIceBreaker.value = true;
            }
            else {
                emit('free-ice-break');
            }
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                (_unref(shouldRenderIceBreaker))
                    ? (_openBlock(), _createBlock(BaseCtaSidebarControl, {
                        key: 0,
                        title: _ctx.$t('setup.ice_breakers_title'),
                        subtitle: _ctx.$t('setup.ice_breakers_subtitle', { time: _unref(iceBreakersRetroStartsAt) }),
                        "button-type": _unref(shouldRenderIceBreakerButton) ? 'normal' : 'none',
                        "button-text": _ctx.$t('setup.ice_breakers_button'),
                        "button-loading": _unref(shouldButtonBeLoading),
                        image: require('@/assets/images/sidebarParticipantControl/ice-breaker-dude.svg'),
                        onClick: handleBreakTheIce
                    }, {
                        label: _withCtx(() => [
                            (!_unref(canUseIceBreakers))
                                ? (_openBlock(), _createBlock(NonFreeLabel, { key: 0 }))
                                : _createCommentVNode("", true)
                        ]),
                        _: 1
                    }, 8, ["title", "subtitle", "button-type", "button-text", "button-loading", "image"]))
                    : _createCommentVNode("", true),
                (_unref(shouldRenderWritingNotDone))
                    ? (_openBlock(), _createBlock(BaseCtaSidebarControl, {
                        key: 1,
                        title: _ctx.$t('writing.title'),
                        subtitle: _ctx.$t('writing.subtitle'),
                        "button-type": "normal",
                        "button-text": _ctx.$t('writing.not_done_button'),
                        image: require('@/assets/images/sidebarParticipantControl/writing-not-done-dude.svg'),
                        "has-timer": true,
                        "timer-started-at": _unref(writingStartedAt),
                        "timer-minutes": _unref(writingDuration),
                        "button-loading": _unref(shouldButtonBeLoading),
                        onClick: _cache[0] || (_cache[0] = ($event) => (_unref(submitDoneWritingValue)(true)))
                    }, null, 8, ["title", "subtitle", "button-text", "image", "timer-started-at", "timer-minutes", "button-loading"]))
                    : (_unref(shouldRenderWritingDone))
                        ? (_openBlock(), _createBlock(BaseCtaSidebarControl, {
                            key: 2,
                            title: _ctx.$t('writing.title'),
                            subtitle: _ctx.$t('writing.subtitle'),
                            "button-type": "undo",
                            "button-text": _ctx.$t('writing.done_button'),
                            image: require('@/assets/images/sidebarParticipantControl/writing-done-dude.svg'),
                            "has-timer": true,
                            "timer-started-at": _unref(writingStartedAt),
                            "timer-minutes": _unref(writingDuration),
                            "button-loading": _unref(shouldButtonBeLoading),
                            onClick: _cache[1] || (_cache[1] = ($event) => (_unref(submitDoneWritingValue)(false)))
                        }, null, 8, ["title", "subtitle", "button-text", "image", "timer-started-at", "timer-minutes", "button-loading"]))
                        : (_unref(shouldRenderPostingYou))
                            ? (_openBlock(), _createBlock(BaseCtaSidebarControl, {
                                key: 3,
                                title: _ctx.$t('posting.title'),
                                subtitle: _ctx.$t('posting.you_subtitle'),
                                "button-type": "normal",
                                "button-text": _ctx.$t('posting.button'),
                                image: require('@/assets/images/sidebarParticipantControl/posting-dude.svg'),
                                "has-timer": true,
                                "timer-started-at": _unref(turnStartedAt),
                                "timer-minutes": _unref(expectedPostingTurnDurationInMinutes),
                                "button-loading": _unref(shouldButtonBeLoading),
                                onClick: _cache[2] || (_cache[2] = ($event) => (progressModal.value = 'endTurn'))
                            }, null, 8, ["title", "subtitle", "button-text", "image", "timer-started-at", "timer-minutes", "button-loading"]))
                            : (_unref(shouldRenderPostingOther))
                                ? (_openBlock(), _createBlock(BaseCtaSidebarControl, {
                                    key: 4,
                                    title: _ctx.$t('posting.title'),
                                    subtitle: _ctx.$t('posting.other_subtitle', { name: _unref(currentPosterFirstName) }),
                                    "button-type": "none",
                                    image: require('@/assets/images/sidebarParticipantControl/posting-dude.svg')
                                }, null, 8, ["title", "subtitle", "image"]))
                                : (_unref(shouldRenderGroupingWithoutSuggestions))
                                    ? (_openBlock(), _createBlock(BaseCtaSidebarControl, {
                                        key: 5,
                                        title: _ctx.$t('grouping.title'),
                                        subtitle: _ctx.$t('grouping.subtitle_without_suggestions'),
                                        "button-type": "normal",
                                        "button-text": _ctx.$t('grouping.button'),
                                        image: require('@/assets/images/sidebarParticipantControl/grouping-dude-without-suggestions.svg'),
                                        "button-disabled": _unref(shouldButtonBeLoading),
                                        onClick: makeGroupingSuggestions
                                    }, null, 8, ["title", "subtitle", "button-text", "image", "button-disabled"]))
                                    : (_unref(shouldRenderGroupingWithSuggestions))
                                        ? (_openBlock(), _createBlock(BaseCtaSidebarControl, {
                                            key: 6,
                                            title: _ctx.$t('grouping.title'),
                                            subtitle: _ctx.$t('grouping.subtitle_with_suggestions'),
                                            image: require('@/assets/images/sidebarParticipantControl/grouping-dude-with-suggestions.svg')
                                        }, null, 8, ["title", "subtitle", "image"]))
                                        : (_unref(shouldRenderVotingNotDone))
                                            ? (_openBlock(), _createBlock(BaseCtaSidebarControl, {
                                                key: 7,
                                                title: _ctx.$t('voting.title'),
                                                subtitle: _ctx.$t('voting.subtitle'),
                                                "button-type": "normal",
                                                "button-text": _ctx.$t('voting.not_done_button'),
                                                image: _unref(votingImage),
                                                "button-loading": _unref(shouldButtonBeLoading),
                                                onClick: _cache[3] || (_cache[3] = ($event) => (_unref(submitDoneVotingValue)(true)))
                                            }, null, 8, ["title", "subtitle", "button-text", "image", "button-loading"]))
                                            : (_unref(shouldRenderVotingDone))
                                                ? (_openBlock(), _createBlock(BaseCtaSidebarControl, {
                                                    key: 8,
                                                    title: _ctx.$t('voting.title'),
                                                    subtitle: _ctx.$t('voting.subtitle'),
                                                    "button-type": "undo",
                                                    "button-text": _ctx.$t('voting.done_button'),
                                                    image: _unref(votingImage),
                                                    "button-loading": _unref(shouldButtonBeLoading),
                                                    onClick: _cache[4] || (_cache[4] = ($event) => (_unref(submitDoneVotingValue)(false)))
                                                }, null, 8, ["title", "subtitle", "button-text", "image", "button-loading"]))
                                                : (_unref(shouldRenderDiscussion))
                                                    ? (_openBlock(), _createBlock(BaseCtaSidebarControl, {
                                                        key: 9,
                                                        title: _ctx.$t('discuss.title'),
                                                        subtitle: _ctx.$t('discuss.subtitle'),
                                                        "button-type": "none",
                                                        image: require('@/assets/images/sidebarParticipantControl/discuss-dude.svg'),
                                                        "has-timer": !!_unref(currentGroup),
                                                        "timer-started-at": _unref(currentGroup) && _unref(currentGroup).discussionStartedAt,
                                                        "timer-minutes": _unref(currentGroup) && _unref(currentGroup).minutes
                                                    }, null, 8, ["title", "subtitle", "image", "has-timer", "timer-started-at", "timer-minutes"]))
                                                    : _createCommentVNode("", true)
            ]));
        };
    }
});
